import React from 'react';
import { StoreSubscribe } from '../../../providers/global-store-provider';
import AccountMenu from '../../common/layout/AccountMenu';
import { inIframe } from '../libs/helpers';

class CommonLayout extends React.Component {

  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  renderUserInfo() {
    return (
      <StoreSubscribe>
        {store => {
          if (store.state.auth.loggedIn)
            return <div className="common-layout-user">
              <AccountMenu noName />
            </div>
          return <div />
        }
        }
      </StoreSubscribe>
    )
  }
  render() {

    return (
      <div className="common-layout">
        {!inIframe() && this.renderUserInfo()}
        {this.props.children}
      </div>
    );
  }
}


export default CommonLayout;
